import React from "react";
import {
  Box,
  Image,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Text,
} from "@chakra-ui/react";
import { TriangleUpIcon } from "@chakra-ui/icons";

interface VideoModalProps {
  videoId: string;
  overlayText: string;
}

export default function VideoModal({ videoId, overlayText }: VideoModalProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box position="relative" maxW="350px" mx="auto" cursor="pointer" onClick={onOpen}>
        <Image
          src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
          alt="Video thumbnail"
          borderRadius="12px"
          w="100%"
        />

        <IconButton
          aria-label="Play video"
          icon={<TriangleUpIcon transform="rotate(90deg)" />}
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          boxSize="64px"
          borderRadius="full"
          bg="pink.500"
          color="white"
          _hover={{ bg: "blackAlpha.800" }}
        />
        <Box
          position="absolute"
          bottom="0"
          left="0"
          w="100%"
          h="100px"
          bg="rgba(0, 0, 0, 0.4)"
          color="white"
          p={3}
          borderBottomRadius="md"
          justifyContent="center"
          alignContent="center"
        >
          <Text fontSize="lg" fontWeight="semibold" align="center">
            {overlayText}
          </Text>
        </Box>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} size="2xl" isCentered>
        <ModalOverlay />
        <ModalContent bg="blackAlpha.500" boxShadow="none" m={0}>
          <ModalCloseButton color="white" zIndex={2} right={0} top={0} />
          <ModalBody p={0}>
            <Box margin="auto">
              {isOpen && (
                <iframe
                  width="100%"
                  height="500px"
                  src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
                  title="YouTube video player"
                  allow="autoplay; encrypted-media; picture-in-picture"
                  allowFullScreen
                  style={{ borderRadius: "12px", border: "none" }}
                />
              )}
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
